import apolloClient from "core/graphql/apolloClient";
import customerActions from "../actions";
import commonActions from "../../common/actions";
import queryLoader from "app/graphql/queryLoader";
import messagesActions from "core/state/redux/data/messages/actions";
import queryActions from "core/state/redux/data/queries/actions";

export default async (store, action) => {
  try {
    const { data } = await apolloClient.query({
      query: queryLoader("getCustomer"),
      variables: action,
      fetchPolicy: "no-cache",
    });

    if (!data.customer || !data.customer) {
      console.log("GraphQL response", data);
      throw new Error("No customer information retrieved.");
    }

    if (data.customer && action.isLoggedIn === false) {
      store.dispatch(customerActions.setCustomerInformation(data.customer));
      store.dispatch(
        customerActions.getCartInformation(undefined, action.cartToken)
      );
      store.dispatch(
        messagesActions.addMessage(
          "You have successfully logged in.",
          "success"
        )
      );
      // store.dispatch(queryActions.removeQuery());
    } else {
      if (action.email !== data.customer.email && action.email !== "") {
        data.customer.email = action.email;
      }
      store.dispatch(
        customerActions.setCustomerInformation(data.customer, action.isLoggedIn)
      );
    }
  } catch (error) {
    store.dispatch(messagesActions.addMessage(error.toString(), "danger"));
    store.dispatch(commonActions.unlock());
    store.dispatch(queryActions.removeQuery());
    return;
  }
};
